import { Navigate } from "react-router-dom";
import { getTenant } from "../shared/config/tenantConfiguration";
import CompanyProfile from "../pages/CompanyProfile";

const ProtectedCompanyProfile = () => {
  const tenant = getTenant();
  
  // Check if tenant is BankLingo (default tenant)
  const isBankLingo = tenant.companyName?.toLowerCase().includes("banklingo") || 
                       tenant.cssName === "default" ||
                       !tenant.companyName;
  
  // Redirect to landing page if not BankLingo
  if (!isBankLingo) {
    return <Navigate to="/landing" replace />;
  }
  
  return <CompanyProfile />;
};

export default ProtectedCompanyProfile;
